import { render, staticRenderFns } from "./EmergencyCase.vue?vue&type=template&id=32059143&scoped=true&"
import script from "./EmergencyCase.vue?vue&type=script&lang=js&"
export * from "./EmergencyCase.vue?vue&type=script&lang=js&"
import style0 from "./EmergencyCase.vue?vue&type=style&index=0&id=32059143&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32059143",
  null
  
)

export default component.exports